import { render, staticRenderFns } from "./Translatable.vue?vue&type=template&id=8ec0b3f8&"
import script from "./Translatable.vue?vue&type=script&lang=js&"
export * from "./Translatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports